import { useLayoutEffect } from "react";
import { MatsushimaAutoLogo } from "./MatsushimaAutoLogo";

type FullscreenLogoIntroProps = {
  onComplete: () => void;
};

export function FullscreenLogoIntro({
  onComplete,
}: FullscreenLogoIntroProps) {
  useLayoutEffect(() => {
    const originalOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.documentElement.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <div
      className="logo-intro"
      aria-hidden="true"
      data-testid="logo-intro"
    >
      <MatsushimaAutoLogo
        animate
        intro
        onAnimationComplete={onComplete}
      />
    </div>
  );
}
